import React from 'react';
import { CardElement } from '@stripe/react-stripe-js';

import styles from './StripeCardElement.less';

const CARD_ELEMENT_OPTIONS = {
  classes: {
    base: styles.input,
    invalid: styles.invalidInput,
    focus: styles.focusedInput,
  },
};

type Props = {
  disabled?: boolean;
};

const StripeCardElement: React.FC<Props> = ({ disabled = false }) => {
  return <CardElement options={{ ...CARD_ELEMENT_OPTIONS, disabled }} />;
};

export default StripeCardElement;
